const MHeaderLine = () => {
  return (
    <div className="relative w-full h-fit">
      <div className="relative w-full h-fit flex items-center">
        <div className="relative w-fit min-w-72 2xl:min-w-80 h-fit hidden lg:block border-r bg-light  pt-2 pb-1">
          <p className=" text-center">
            <span>실시간&nbsp;문의현황</span>
            &nbsp;&nbsp;
          </p>
        </div>
        <div className="relative w-fit h-fit flow-text  bg-primary text-white  pt-2 pb-1">
          <ul className="flex gap-5 flow-wrap text-base">
            <li>김00 (곰팡이 제거 및 재오염 방지)</li>
            <li>|</li>
            <li>이00 (드론크리닝)</li>
            <li>|</li>
            <li>오00 (태양광 크리닝)</li>
            <li>|</li>
            <li>신00 (빌딩크리닝)</li>
            <li>|</li>
            <li>임00 (호텔제품판매)</li>
            <li>|</li>
            <li>김00 (학교시설 크리닝)</li>
            <li>|</li>
            <li>이00 (곰팡이 제거 및 재오염 방지)</li>
            <li>|</li>
            <li>오00 (태양광 크리닝)</li>
            <li>|</li>
            <li>신00 (학교시설 크리닝)</li>
            <li>|</li>
            <li>임00 (빌딩크리닝)</li>
            <li>|</li>
          </ul>
          <ul className="flex gap-5 flow-wrap text-base">
            <li>김00 (곰팡이 제거 및 재오염 방지)</li>
            <li>|</li>
            <li>이00 (드론크리닝)</li>
            <li>|</li>
            <li>오00 (태양광 크리닝)</li>
            <li>|</li>
            <li>신00 (빌딩크리닝)</li>
            <li>|</li>
            <li>임00 (호텔제품판매)</li>
            <li>|</li>
            <li>김00 (학교시설 크리닝)</li>
            <li>|</li>
            <li>이00 (곰팡이 제거 및 재오염 방지)</li>
            <li>|</li>
            <li>오00 (태양광 크리닝)</li>
            <li>|</li>
            <li>신00 (학교시설 크리닝)</li>
            <li>|</li>
            <li>임00 (빌딩크리닝)</li>
            <li>|</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default MHeaderLine;
